<template>
  <expanding-list :title="(HeaderProps && HeaderProps.title) ? HeaderProps.title : $t('servicesystem.common_objects.job.jobs')"
                  :icon="(HeaderProps && HeaderProps.icon) ? HeaderProps.icon : '$job'"
                  :list="JobList"
                  :cardcount="true"
                  :maxcontentheight="'45vh'"
                  :loading="loading">

    <template slot="list-item"
              slot-scope="{ item }">
      <job-li :key="item.Id"
              :jobItem="item"
              :previewMode="true"
              :showStatus="true">
      </job-li>
    </template>

  </expanding-list>
</template>


<script>
import ExpandingList from "@/components/ExpancionPanels/Generic/ExpandingList.vue";
import JobLi from "@/components/ListItems/JobListItem/JobListItem.vue";

export default {
  name: "JobListPreview",
  props: {
    HeaderProps: Object, //{title, icon}
    JobList: [Array, Boolean], //Usually an array, but false on error
    loading: Boolean,
  },
  components: {
    ExpandingList,
    JobLi,
  },

  data: () => ({}),

  mounted() {},

  methods: {},

  computed: {
    disabled() {
      return !this.JobList || this.JobList.length < 1;
    },

    count() {
      return this.JobList && this.JobList.length > 0 ? this.JobList.length : 0;
    },
  },

  watch: {},
};
</script>